import { render, staticRenderFns } from "./canteenRecord.vue?vue&type=template&id=59f46fd2&scoped=true"
import script from "./canteenRecord.vue?vue&type=script&lang=js"
export * from "./canteenRecord.vue?vue&type=script&lang=js"
import style0 from "./canteenRecord.vue?vue&type=style&index=0&id=59f46fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f46fd2",
  null
  
)

export default component.exports